module.exports = __webpack_public_path__ + "static/BodoniStd-Book-1e11232fd8a7611a4a1ccc89384562b0.woff2";